import { render, staticRenderFns } from "./GameItem.vue?vue&type=template&id=4fcdb3f8"
import script from "./GameItem.vue?vue&type=script&lang=js"
export * from "./GameItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports